"use client";

/**
 * Read the current site config from the nearest SiteConfigProvider.
 *
 * Returns `defaultConfig` if no provider is mounted (e.g. in a unit test
 * with no wrapping provider). In the public site, `LiveSiteConfigProvider`
 * is mounted at the root of `app/layout.tsx` and owns the 60-second poll
 * of `/site-config.json`. In the admin preview, `SiteConfigProvider`
 * injects the draft config from a prop.
 *
 * Usage (client components only — add `"use client"` to consumers):
 *
 *   const config = useSiteConfig();
 *   <img src={config.brand.logoUrl || "/images/augustine-logo.png"} />
 */

import { useSiteConfigContext } from "./SiteConfigContext";
import { defaultConfig, type SiteConfig } from "./siteConfig";

export function useSiteConfig(): SiteConfig {
  return useSiteConfigContext() ?? defaultConfig;
}
